define.alias("shared/components/shared/social/facebook-modal", "settings/components/shared/social/facebook-modal");